import { css } from '@emotion/core'

export const fluidImage = css`
  width: inherit;
`
